import styled from '@emotion/styled'
import * as React from 'react'

import { breakpoints, spacing } from 'main/ui'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (min-width: ${breakpoints.lg}px) {
    flex-direction: row;
  }
`

const ChildContainer = styled.div`
  flex-basis: 0;
  flex-grow: 1;
  min-width: 0;

  :not(:last-child) {
    margin-bottom: ${spacing.majorScale(2)}px;
  }

  @media (min-width: ${breakpoints.lg}px) {
    :not(:last-child) {
      margin-bottom: 0;
      margin-right: ${spacing.majorScale(2)}px;
    }
  }
`

export default function FormGroup(props: { children: React.ReactNode }) {
  const { children } = props

  return (
    <Container>
      {childrenAsArray(children).map((child, i) => (
        <ChildContainer key={i}>{child}</ChildContainer>
      ))}
    </Container>
  )
}

function childrenAsArray(children: React.ReactNode) {
  if (!children) return []

  return Array.isArray(children) ? children.filter(Boolean) : [children]
}
